import createReducer from 'utils/create-reducer';
import { createLoader } from 'utils/create-loader';
import { handleSwapCategory, handleSwapSubcategory } from '../entities/Category';

const getCategoriesLoader = createLoader('CATEGORY_LIST', 'categories');
const getCategoryLoader = createLoader('CATEGORY_SLUG', 'category');
const getSubCategoryLoader = createLoader('SUBCATEGORY_SLUG', 'subCategory');
const upsertCategoryLoader = createLoader('UPSERT_CATEGORY', 'newCategory');
const createSubcategoryLoader = createLoader('CREATE_SUBCATEGORY', 'newSubcategory');
const updateSubcategoryLoader = createLoader('UPDATE_SUBCATEGORY', 'newSubcategory');
const deleteCategoryLoader = createLoader('DELETE_CATEGORY', 'deleteCategory');
const deleteSubcategoryLoader = createLoader('DELETE_CATEGORY', 'deleteSubcategory');

const actionTypes = {
  swapCategory: 'SWAP_CATEGORY',
  swapSubcategory: 'SWAP_SUBCATEGORY',
};

const initialState = {};
export const reducer = createReducer(initialState, {
  [actionTypes.swapCategory]: (state, action) => handleSwapCategory(action)(state),
  [actionTypes.swapSubcategory]: (state, action) => handleSwapSubcategory(action)(state),
});

export const categorySwapIndex = (id1, id2) => ({
  type: actionTypes.swapCategory,
  id1,
  id2,
});
export const subcategorySwapIndex = (catId, id1, id2) => ({
  type: actionTypes.swapSubcategory,
  catId,
  id1,
  id2,
});
